import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _ListingTermsContainer = styled.div`
  position: absolute;
  display: flex;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    top: 50%;
    transform: translate(-50%, -50%);
  }
`


export const _ModalContainer = styled.div`
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`
export const _ViewTermsAgreeText = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 24px;

`

export const _ViewTermsAgreeContainer = styled.div`
  padding: 24px;
  min-width: 320px;
  background-color: white;
  border-radius: 10px;
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`
